import {
  EmployeeLegalEntitiesFilterQuery,
  EmployeeTeamsFilterQuery,
  GetWorkAreasQuery,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  EMPLOYEE_STATUS,
  SHIFT_CONFLICTS,
  SHIFT_WITHOUT_CONFLICTS,
} from 'modules/shift_management/hooks/reducers/filter'

interface BuildOptionsProps {
  workAreasData: GetWorkAreasQuery | undefined
  teamsData: EmployeeTeamsFilterQuery | undefined
  legalEntitiesData: EmployeeLegalEntitiesFilterQuery | undefined
  locationsData: Array<{ id: string; name: string }>
}
const sortByLabel = (a: { label: string }, b: { label: string }) => a.label.localeCompare(b.label)
const buildOptions = ({
  workAreasData,
  teamsData,
  legalEntitiesData,
  locationsData,
}: BuildOptionsProps) => {
  const workAreasOptions =
    workAreasData?.locations.workAreas
      .map((workArea) => ({
        value: workArea.id,
        label: `${workArea.location?.name} - ${workArea.name}`,
      }))
      .sort(sortByLabel) || []

  const teamsOptions =
    teamsData?.teams.teams
      .map(({ name, id }) => ({
        label: name,
        value: id,
      }))
      .sort(sortByLabel) || []

  const legalEntitiesOptions =
    legalEntitiesData?.companies.legalEntities
      .map(({ legalName, id }) => ({
        label: legalName,
        value: id,
      }))
      .sort(sortByLabel) || []

  const employeeStatusesOptions = [
    {
      value: EMPLOYEE_STATUS.active,
      label: i18n.t('employees.active'),
    },
    {
      value: EMPLOYEE_STATUS.terminated,
      label: i18n.t('employees.terminated'),
    },
  ]

  const statusOptions = [
    {
      value: SHIFT_CONFLICTS,
      label: i18n.t('shift_management.filters.shift_conflicts'),
    },
    {
      value: SHIFT_WITHOUT_CONFLICTS,
      label: i18n.t('shift_management.filters.shift_without_conflicts'),
    },
  ]
  const locationsOptions = locationsData
    .map(({ id, name }) => ({ value: id, label: name }))
    .sort(sortByLabel)

  return {
    teamsOptions,
    employeeStatusesOptions,
    legalEntitiesOptions,
    statusOptions,
    workAreasOptions,
    locationsOptions,
  }
}

export { buildOptions }
